
<script>
  import { Card, Avatar} from "flowbite-svelte";
  //import Icon from "@iconify/svelte";

  export let name, src, w, h;
  let expanded = false;
</script>
<div class="justify-center outer">
<Card class="justify-center">
<div class="justify-center place-self-center text-center space-x-4 ">
  <figure>
  <div class="crop-circular" style="width: {w}px; height: {h}px">
  <img class="rounded" src={src} alt={name} on:click={()=>{expanded=!expanded}}/>
    </div>
<!--
  <div on:click={()=>{expanded=!expanded}}>

  <Icon class="justify-center" style="scale: 200%" icon="material-symbols:expand-circle-down" rotate={expanded? "180deg":"0deg"} aria-expanded={expanded} >
  </Icon>
   </div>-->
  <div class="contents" hidden={!expanded}>
    {#if expanded}
      <span class="innards">
    <slot></slot>
        </span>
      {/if}
  </div></figure></div>
</Card>
</div>


<style>

  .crop-circular{
    margin-left: auto;
    margin-right: auto;

    /*
    height: 264px;
    width: 300px;*/
    border-radius: 50%;
    position: relative;
    overflow: hidden;
  }
  img{
    display: inline;
    margin: 0 auto;
    height: 100%;
    width: auto;
    cursor: pointer;
  }
  Card{
    border-color: blanchedalmond;
  }
  .outer{
    margin-bottom:4vh;
  }

</style>